export default "__VITE_ASSET__CsPD3Vpg__"